module.exports = __webpack_public_path__ + "img/logo.3330c782.png";